<template>
  <div class="btn__wrapper">
    <btn-select
      v-for="answer in answers"
      @click.native.once="handleClick(answer.text)"
    ><img :src="answer.image"><span>{{ answer.text }}</span>
    </btn-select>
  </div>
</template>

<script>
import BtnSelect from '../common/BtnSelect'

export default {
  components: {
    'btn-select': BtnSelect
  },
  data () {
    return {
      answers: [
        {
          text: 'Primary Residence',
          image: require('../../assets/img/home.svg')
        },
        {
          text: 'Secondary Home',
          image: require('../../assets/img/home_1.svg')
        },
        {
          text: 'Investment Property',
          image: require('../../assets/img/home_2.svg')
        }
      ]
    }
  },
  methods: {
    handleClick (value) {
      this.$emit('input', value)
    }
  }
}
</script>
